import { render, staticRenderFns } from "./order-modal-estimations.vue?vue&type=template&id=5137640a"
import script from "./order-modal-estimations.vue?vue&type=script&lang=js"
export * from "./order-modal-estimations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports